import { render } from "./IconCart.vue?vue&type=template&id=6ca7a920"
const script = {}

import "./IconCart.vue?vue&type=style&index=0&id=6ca7a920&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__